export enum DivisionTableColumns {
  DivisionId = "divisionId",
  NameLocal = "nameLocal",
  NameLatin = "nameLatin",
  AbbreviationLocal = "abbreviationLocal",
  AbbreviationLatin = "abbreviationLatin",
  ConferenceId = "conferenceId",
  Conference = "conference",
  ExternalId = "externalId",
}
